import "element-closest";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import Router from "./routes";

// Store
import configureStore from "./stores";

// react-router history
import myHistory from "./myHistory";

const store = configureStore();

// eslint-disable-next-line
createRoot(document.getElementById("app")).render(
  <Provider store={store}>
    <Router store={store} history={myHistory} />
  </Provider>
);
